var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "col-md-4 article-snippet" }, [
    _c("a", { attrs: { href: _vm.guid, target: "_blank" } }, [
      _c("img", {
        staticClass: "img-fluid",
        attrs: { src: _vm.featuredImageUrl }
      })
    ]),
    _vm._v(" "),
    _c("h3", { staticStyle: { "margin-top": "1em" } }, [
      _vm._v(_vm._s(_vm.title))
    ]),
    _vm._v(" "),
    _c("p", { staticClass: "snippet" }, [
      _vm._v(_vm._s(_vm.formattedDescription))
    ]),
    _vm._v(" "),
    _c("p", [
      _c("a", { staticClass: "readmore", attrs: { href: _vm.guid } }, [
        _vm._v("Read More")
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }